import {HelpQueryType} from '../type';

export function getHelpUrl({
  queryType,
  queryValue,
}: {
  queryType: HelpQueryType;
  queryValue: number | string;
}) {
  if (queryType === HelpQueryType.Id) {
    return `/help/${queryValue}`;
  }
  return `/help?${queryType}=${queryValue}`;
}
